module.exports = __webpack_public_path__ + "img/MY-flag.97115bfa.png";